import { render, staticRenderFns } from "./FastOpportunity.vue?vue&type=template&id=2a6f07fe&scoped=true&"
import script from "./FastOpportunity.vue?vue&type=script&lang=js&"
export * from "./FastOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./FastOpportunity.vue?vue&type=style&index=0&id=2a6f07fe&prod&scoped=true&lang=css&"
import style1 from "./FastOpportunity.vue?vue&type=style&index=1&id=2a6f07fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f07fe",
  null
  
)

export default component.exports